import React from 'react';
import ProjectItem from '../ProjectItem';
import { AllProjectsContainer, ProjectsList } from '../AllProjectsPage/styles';
import { formatSrcSet } from '../../../utils/formatURLs';
import { TechnologyPageWrapper } from './styles';
import { Project, UploadFile } from '../../../types/schema';

export type RelatedProject = Pick<
  Project,
  | 'documentId'
  | 'title'
  | 'slug'
  | 'locale'
  | 'description'
  | 'companyName'
  | 'clientLocation'
  | 'type'
  | 'featuredDescription'
  | 'thumbnailImage'
>;

export type TechnologyPageTemplateProps = {
  language?: string;
  title: string;
  html: string;
  image: string;
  slug?: string;
  relatedProjects?: RelatedProject[];
};

const stripInlineStyles = (html: string): string =>
  html.replace(/<span[^>]*>([\s\S]*?)<\/span>/gi, '$1').replace(/(<[^>]+)\sstyle="[^"]*"/gi, '$1');

const TechnologyPageTemplate: React.FC<TechnologyPageTemplateProps> = ({
  title,
  html,
  image,
  language,
  relatedProjects,
}) => {
  const sanitizedHtml = stripInlineStyles(html);
  const isEn = language === 'en';

  return (
    <>
      <TechnologyPageWrapper>
        <div>
          <div>
            <h1 style={{ margin: 0, padding: 0, lineHeight: '70px', fontSize: '48px' }}>{title}</h1>
            {image && <img srcSet={formatSrcSet(image, 'technology')} alt={title} />}
          </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      </TechnologyPageWrapper>
      {relatedProjects && relatedProjects.length > 0 && (
        <AllProjectsContainer>
          <h2>{isEn ? 'Projects using this technology' : 'Projetos que usam esta tecnologia'}</h2>
          <ProjectsList>
            {relatedProjects.map((project) => (
              <ProjectItem
                key={project.documentId}
                project={project as Project}
                language={language || 'pt'}
                thumbnailImage={formatSrcSet(
                  project.thumbnailImage as UploadFile,
                  'projectThumbnail',
                )}
              />
            ))}
          </ProjectsList>
        </AllProjectsContainer>
      )}
    </>
  );
};

export default TechnologyPageTemplate;
